import React from "react";
import { motion } from "framer-motion";
import { Lock, Sparkles, Eye } from "lucide-react";
import { useTelegram } from "../hooks/useTelegram";

interface GalleryBlurSectionProps {
  onSubscribeClick: () => void;
}

const PREVIEWS = [
  { id: 1, title: "Exclusivo VIP #1", category: "Video Full HD", gradient: "linear-gradient(135deg, rgb(var(--c-crimson-rgb) / 0.35), rgb(var(--c-crimson-rgb) / 0.10))" },
  { id: 2, title: "Sesión Privada", category: "Fotos Set Completo", gradient: "linear-gradient(135deg, rgb(var(--c-crimson-rgb) / 0.28), rgb(var(--c-crimson-rgb) / 0.06))" },
  { id: 3, title: "Detrás de Cámaras", category: "Contenido 4K", gradient: "linear-gradient(135deg, rgb(var(--c-crimson-rgb) / 0.12), rgb(var(--c-crimson-rgb) / 0.30))" },
  { id: 4, title: "Lo Más Nuevo", category: "Estreno Semanal", gradient: "linear-gradient(135deg, rgb(var(--c-crimson-rgb) / 0.08), rgb(var(--c-crimson-rgb) / 0.32))" },
];

export const GalleryBlurSection: React.FC<GalleryBlurSectionProps> = ({ onSubscribeClick }) => {
  const { hapticFeedback } = useTelegram();

  const handleItemClick = () => {
    hapticFeedback.impact("medium");
    onSubscribeClick();
  };

  return (
    <div className="w-full py-6 px-4 space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Sparkles className="w-5 h-5 text-brand animate-pulse" />
          <h2 className="text-lg font-bold text-[color:var(--c-text)] tracking-wide">Galería Exclusiva VIP</h2>
        </div>
        <span className="text-xs text-brand font-medium px-2 py-0.5 rounded-full bg-brand/10 border border-brand/20">
          500+ Videos
        </span>
      </div>

      <div className="grid grid-cols-2 gap-3">
        {PREVIEWS.map((item) => (
          <motion.div
            key={item.id}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.97 }}
            onClick={handleItemClick}
            style={{ background: item.gradient }}
            className={`relative rounded-xl overflow-hidden aspect-[4/5] border border-brand/20 shadow-lg cursor-pointer group backdrop-blur-md`}
          >
            {/* Background Blur Overlay */}
            <div className="absolute inset-0 bg-[color:var(--c-surface)] backdrop-blur-md group-hover:backdrop-blur-sm transition-all duration-300 flex flex-col items-center justify-center p-3 text-center">
              <div className="w-12 h-12 rounded-full bg-brand/20 border border-brand/40 flex items-center justify-center mb-2 group-hover:scale-110 transition-transform">
                <Lock className="w-6 h-6 text-brand" />
              </div>
              <span className="text-xs font-semibold text-[color:var(--c-text)] line-clamp-1">{item.title}</span>
              <span className="text-[10px] text-[color:var(--c-text-dim)] mt-0.5">{item.category}</span>
            </div>

            {/* Hover reveal text */}
            <div className="absolute bottom-2 left-2 right-2 flex items-center justify-center gap-1 text-[11px] font-medium text-brand bg-[color:var(--c-surface-solid)] py-1 rounded-lg border border-brand/30">
              <Eye className="w-3 h-3" />
              <span>Ver en VIP</span>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};
